"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchToastModalState = void 0;
var PunchToastModalState;
(function (PunchToastModalState) {
    PunchToastModalState[PunchToastModalState["CLOSE"] = 0] = "CLOSE";
    PunchToastModalState[PunchToastModalState["SUBMIT_MISSED_PUNCH"] = 1] = "SUBMIT_MISSED_PUNCH";
    PunchToastModalState[PunchToastModalState["SUBMIT_PUNCH_EDIT"] = 2] = "SUBMIT_PUNCH_EDIT";
    PunchToastModalState[PunchToastModalState["DELETE_PUNCH"] = 3] = "DELETE_PUNCH";
    PunchToastModalState[PunchToastModalState["ACCEPT_PUNCH_CORRECTION"] = 4] = "ACCEPT_PUNCH_CORRECTION";
    PunchToastModalState[PunchToastModalState["UPDATE_PUNCH_CORRECTION"] = 5] = "UPDATE_PUNCH_CORRECTION";
})(PunchToastModalState = exports.PunchToastModalState || (exports.PunchToastModalState = {}));
